import { useTranslation } from 'react-i18next'
import { Container } from '../styles'
import Typography from 'ui/src/components/Typography'
import Box from 'ui/src/components/Box'
import Button from 'ui/src/components/Button'
import Header from 'ui/src/components/Header'
import globalStore from 'store'
import invariant from 'tiny-invariant'
import { useState } from 'react'
import Services from 'services'
import { toast } from 'react-toastify'
import { toastStyle } from 'util/toast'

interface VerifyYourEmailProps {
  email: string
}

const VerifyYourEmail: React.FC<VerifyYourEmailProps> = ({ email }) => {
  const user = globalStore(state => state.user)
  const [isResendingEmail, setResendingEmail] = useState(false)

  const { t } = useTranslation('translations', { keyPrefix: 'message.verifyYourEmail' })

  invariant(user, 'Expected value to be a user')

  const resendEmail = async () => {
    setResendingEmail(true)
    Services.EmailVerification.resendVerificationEmail({ email })
      .then(() => {
        toast.success(t('resendEmail.success'), toastStyle)
        setResendingEmail(false)
      })
      .catch(() => {
        toast.error('resendEmail.error', toastStyle)
        setResendingEmail(false)
      })
  }

  return (
    <>
      <Header />
      <Container>
        <Box
          sx={{
            maxWidth: { xl: '754px', lg: '754px', md: '754px', sm: '600px', xs: '500px' },
            padding: { sm: 4, xs: 4 },
          }}
        >
          <Box
            sx={{
              borderRadius: 1,
              boxShadow: 1,
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: 'primary.contrastText',
              width: 'fit-content',
              p: 6,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                mb: 3,
                color: 'primary.main',
              }}
            >
              {t('title')}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                mb: 4,
                color: '#322F2F',
              }}
            >
              {t('message1')}
              <Typography
                component="span"
                variant="h6"
                sx={{
                  color: '#322F2F',
                  fontWeight: 500,
                }}
              >
                {email}
              </Typography>
            </Typography>
            <Typography
              variant="h6"
              sx={{
                mb: 4,
                color: '#322F2F',
              }}
            >
              {t('message2')}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                gap: 2,
              }}
            >
              <Button
                sx={{ px: 3, py: 1.5 }}
                variant="contained"
                onClick={resendEmail}
                loading={isResendingEmail}
              >
                {t('resendEmailButton')}
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  )
}

export default VerifyYourEmail
